import { booleanParser, encodedStringParser } from '../inboundParsers';
import { inboundSelfDataParser } from './utils/selfDataInboundUtils';
function sceneParser(str) {
    const legacyFlashRoomType = str;
    const sceneMap = {
        PokerLobby: 'lobby',
        PokerRoom: 'poker',
        PokerChat: 'mttStaging'
    };
    const scene = sceneMap[legacyFlashRoomType];
    if (!scene) {
        throw new Error(`Unhandled game type / scene '${str}'`);
    }
    return scene;
}
export const JOIN_ROOM_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'inboundSelfData', parser: inboundSelfDataParser },
        { name: 'scene', parser: sceneParser },
        { name: 'loadingRoomMessage', parser: encodedStringParser },
        { name: 'shouldSkipAd', parser: booleanParser }
    ]
};
